var _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRgbpp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.332,
    y: 1.29395,
    width: 7,
    height: 23.3333,
    rx: 3.5,
    transform: "rotate(45 22.332 1.29395)",
    fill: "url(#paint0_linear_47537_77309)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.668,
    y: 2.45996,
    width: 7,
    height: 23.3333,
    rx: 3.5,
    fill: "url(#paint1_linear_47537_77309)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.8242,
    y: 2.45996,
    width: 7,
    height: 23.3333,
    rx: 3.5,
    transform: "rotate(75 23.8242 2.45996)",
    fill: "url(#paint2_linear_47537_77309)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47537_77309",
    x1: 25.832,
    y1: 1.29395,
    x2: 25.832,
    y2: 24.6273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47537_77309",
    x1: 22.168,
    y1: 2.45996,
    x2: 22.168,
    y2: 25.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47537_77309",
    x1: 27.3242,
    y1: 2.45996,
    x2: 27.3242,
    y2: 25.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRgbpp);
export default __webpack_public_path__ + "static/media/Rgbpp.9e85eae27db428e16854320d6b059989.svg";
export { ForwardRef as ReactComponent };